import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/esm/applyDecoratedDescriptor";
var _dec, _class;
// TODO: Use more reselect! Create a getInteractionTypes selector that can be used for reselecting interaction types by
// id(s)
import { Map } from 'immutable';
import interactionTypeRecordForItem from '../util/interactionTypeRecordForItem';
import withStateCache from '../util/withStateCache';
import reduxStore from '../../reduxStore';
import { featureOn } from '../util/featureCheck';
export var getInteractionType = function getInteractionType(state, id) {
  var interactionTypeData = state.getIn(['interactionTypes', id]) || Map();
  var slug = interactionTypeData.get('slug');
  var IntTypeRecord = interactionTypeRecordForItem(slug);
  return new IntTypeRecord(interactionTypeData);
};
var CacheHelper = (_dec = withStateCache(function () {
  return [['interactionTypes']];
}), _class = /*#__PURE__*/function () {
  function CacheHelper() {
    _classCallCheck(this, CacheHelper);
  }
  return _createClass(CacheHelper, [{
    key: "state",
    value:
    // This is needed for withStateCache to work properly :-/
    function state() {
      return reduxStore.getAppState();
    }
  }, {
    key: "interactionTypes",
    value: function interactionTypes(state) {
      return state.get('interactionTypes', Map()).filter(function (intTypeData) {
        return featureOn('interaction_type_rich_fill_blank') ? intTypeData.get('slug') !== 'fill-blank' : intTypeData.get('slug') !== 'rich-fill-blank';
      }).map(function (intTypeData) {
        return getInteractionType(state, intTypeData.get('id'));
      }).valueSeq().toList();
    }
  }]);
}(), _applyDecoratedDescriptor(_class.prototype, "interactionTypes", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "interactionTypes"), _class.prototype), _class);
var cacheHelper = new CacheHelper();

// This is a hack to continue using withStateCache until we implement reselect
export var getInteractionTypes = cacheHelper.interactionTypes.bind(cacheHelper);